import React, { useState, useEffect } from 'react';
import './CookieBanner.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { lang, t } = useLanguage();

  useEffect(() => {
    // Daha önce onaylanıp onaylanmadığını kontrol et
    const isAccepted = localStorage.getItem('cookieAccepted');
    if (!isAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          {lang === 'TR' ? (
            <>
              Web sitemiz, deneyiminizi iyileştirmek için çerezleri kullanmaktadır. 
              Detaylı bilgi almak ve tercihlerinizi yönetmek için <strong>çerez politikamızı</strong> inceleyebilirsiniz.
            </>
          ) : lang === 'AR' ? (
            <>
              يستخدم موقعنا ملفات تعريف الارتباط لتحسين تجربتك. يمكنك مراجعة <strong>سياسة ملفات تعريف الارتباط</strong> للحصول على معلومات مفصلة وإدارة تفضيلاتك.
            </>
          ) : (
            <>
              Our website uses cookies to improve your experience. 
              You can review our <strong>cookie policy</strong> to get detailed information and manage your preferences.
            </>
          )}
        </p>
        <div className="cookie-buttons">
          <button className="btn-all" onClick={handleAccept}>
            {lang === 'TR' ? "Tümünü Onayla" : lang === 'AR' ? "قبول الكل" : "Accept All"}
          </button>
          <button className="btn-reject" onClick={() => setIsVisible(false)}>
            {lang === 'TR' ? "Tümünü Reddet" : lang === 'AR' ? "رفض الكل" : "Reject All"}
          </button>
          <button className="btn-settings" onClick={() => setIsVisible(false)}>
            {lang === 'TR' ? "Tercihleri Düzenle" : lang === 'AR' ? "تعديل التفضيلات" : "Edit Preferences"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;